export const GET_PEER_INFO = '@peers/GET_PEER_INFO' as const;
export const GET_PEERS = '@peers/GET_PEERS' as const;
export const SET_PEERS_PAGE = '@peers/SET_PEERS_PAGE' as const;
